import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnify = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M711.117 625.778h-44.942l-15.929-15.36c68.267-79.643 103.538-188.301 84.196-303.786-26.738-158.151-158.72-284.445-318.007-303.787-240.64-29.582-443.165 172.942-413.582 413.582 19.342 159.288 145.636 291.271 303.787 318.008 115.484 19.342 224.142-15.929 303.784-84.196l15.36 15.929v44.942l241.778 241.778c23.324 23.324 61.44 23.324 84.764 0s23.324-61.44 0-84.764l-241.209-242.347zM369.786 625.778c-141.653 0-256-114.346-256-255.999s114.347-256 256-256c141.653 0 255.998 114.347 255.998 256s-114.344 255.999-255.998 255.999z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMagnify);
export default ForwardRef;
